<template>
    <div>
        <div class="container order-content">
            <div class="manage-main">
                <div class="rule" style="overflow: hidden">
                    <Menu></Menu>
                    <div class="manage-right">
                        <div class="right-title">酒店订单</div>
                        <div :class="isMore?'manage-order manage-order-l':'manage-order'">
                            <div class="input-box">
                                <span>CN单号</span>
                                <input type="text" v-model="OrderNO" maxlength="20">
                                <i v-if="OrderNO!=''" class="iconfont icon-guanbi" @click="OrderNO=''"></i>
                            </div>
                            <div class="input-box">
                                <span>时间类型</span>
                                <div class="select-box">
                                    <select v-model="TimeType">
                                        <option value="0">预订时间</option>
                                        <option value="1">入住时间</option>
                                        <option value="2">离店时间</option>
                                    </select>
                                </div>
                            </div>
                            <div class="input-box date-time">
                                <span>起止时间</span>
                                <input type="text" class="date-time" v-model="Start" @click="calendar.show=true" data-type="time">
                                -
                                <input type="text" class="date-time" v-model="End" @click="calendar.show=true" data-type="time">
                                <DatePicker @select="calendar.select" v-show="calendar.show" :start="calendar.start"
                                            :beginDate="calendar.begin" :endDate="calendar.end">
                                </DatePicker>
                            </div>
                            <div class="more-con">
                                <div class="input-box">
                                    <span>操作员</span>
                                    <!--<div class="select-box">-->
                                    <!--<select v-model="Oper">-->
                                    <!--<option value="1"></option>-->
                                    <!--</select>-->
                                    <!--</div>-->
                                    <input type="text" v-model="Oper" maxlength="3">
                                    <i v-if="Oper!=''" class="iconfont icon-guanbi" @click="Oper=''"></i>

                                </div>
                                <div class="input-box">
                                    <span>酒店名称</span>
                                    <input type="text" v-model="HotelName" maxlength="50">
                                    <i v-if="HotelName!=''" class="iconfont icon-guanbi" @click="HotelName=''"></i>
                                </div>
                                <div class="input-box">
                                    <span>订单来源</span>
                                    <div class="select-box">
                                        <select v-model="Source">
                                            <option value="">全部</option>
                                            <option value="0">手机订房易</option>
                                            <option value="1">PC 端订房易</option>
                                            <option value="2">线下客服</option>
                                            <option value="3">API对接</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-box">
                                    <span>入住人</span>
                                    <input type="text" v-model="GustName" maxlength="50">
                                    <i v-if="GustName!=''" class="iconfont icon-guanbi" @click="GustName=''"></i>
                                </div>
                                <div class="input-box">
                                    <span>支付状态</span>
                                    <div class="select-box">
                                        <select v-model="Payment">
                                            <option value="">全部</option>
                                            <option value="0">未支付</option>
                                            <!--<option value="1">处理中</option>-->
                                            <!--<option value="2">未付清</option>-->
                                            <option value="3">已支付</option>
                                            <option value="4">已退款</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-box">
                                    <span>订单状态</span>
                                    <div class="select-box">
                                        <select v-model="Statu">
                                            <option value="">全部</option>
                                            <option value="0">无效单</option>
                                            <option value="2">已锁定</option>
                                            <option value="8">取消单</option>
                                            <option value="9">新单</option>
                                            <option value="10">已确认</option>
                                            <option value="27">可入住</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="input-box">
                                    <span>客户单号</span>
                                    <input type="text" v-model="GustOrder" maxlength="50">
                                    <i v-if="GustOrder!=''" class="iconfont icon-guanbi" @click="GustOrder=''"></i>
                                </div>
                            </div>
                            <div class="btn-box">
                                <div class="btn manage-search" @click="initData();SearchType='init'">查询</div>
                                <div class="btn manage-out" @click="export2Excel" :class="{'disable':DivDisable}">{{ExcelTxt}}</div>
                                <a id="dlink"  style="display:none;"></a>
                                <a class="pack-up" href="javascript:void(0)" @click="isMore = !isMore">{{isMore?'收起更多条件 >>':'展开更多条件 >>'}}</a>
                            </div>
                        </div>

                        <div class="search-result">
                            <div class="search-result-head">
                                <p>搜索到<span class="price">{{total}}</span>条符合条件的订单</p>
                                <div>
                                    <div :class="SearchType=='getUnpaid'?'btn active':'btn'" @click="getUnpaid();SearchType='getUnpaid'">预订成功待支付({{UnpaidNum}})</div>
                                    <div :class="SearchType=='getCheckIn'?'btn active':'btn'" @click="getCheckIn();SearchType='getCheckIn'">7天内入住({{CheckInNum}})</div>
                                </div>
                            </div>
                            <table class="result-table" id="table">
                                <thead>
                                <tr>
                                    <td style="min-width:181px;">CN单号<br/>预定时间</td>
                                    <td style="width:163px;">酒店名称<br/>房型</td>
                                    <td style="width:55px;">间数</td>
                                    <td style="width:100px;max-width: 125px">入住人</td>
                                    <td style="width:100px;min-width: 100px">入住日期<br/>离店日期</td>
                                    <td style="width:102px;">订单金额 <br>支付状态</td>
                                    <td style="min-width:100px;">结算方式<br>订单状态</td>
                                    <td style="width:132px;">跟单人</td>
                                    <td style="width:55px;">操作</td>
                                </tr>
                                </thead>
                                <tbody v-if="!isLoading">
                                <tr v-for="(item,index) in OrderList">
                                    <td>
                                        <span class="shi" v-if="item.IsRealTime">实</span>
                                        <span class="orange" v-if="!item.IsRealTime">待</span>
                                        <div class="order-number">
                                            <span class="order-btn" @click="routerToDetails(item.OrderNO)"><a
                                                    href="javascript:void(0)" class="name">{{item.OrderNO}}</a></span><br>
                                            <span style="color: #999">{{item.BookingOn|dateToYMDline}} {{item.BookingOn|dateHMS}}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <a class="name" href="javascript:void(0)" :title="item.HotelName">{{item.HotelName}}</a>
                                        <span class="room-type" :title="item.RoomName">{{item.RoomName}}</span>
                                    </td>
                                    <td>{{item.RoomCount}}</td>
                                    <td><p style="max-width: 125px" v-for="g in item.Guest">{{g.FirstName}}{{g.LastName}}</p></td>
                                    <td><span>{{item.CheckInStr|dateToYMDline}}</span><br><span>{{item.CheckOutStr|dateToYMDline}}</span></td>
                                    <td>
                                        <span class="price">{{item.Currency}}{{item.TotalAmount}}</span><br>
                                        <span v-if="item.PaymentType ==0&&!item.NeedPay">未支付</span>
                                        <span v-if="item.PaymentType ==1&&!item.NeedPay">未支付</span>
                                        <span v-if="item.PaymentType ==2&&!item.NeedPay">未支付</span>
                                        <span v-if="item.PaymentType ==3&&!item.NeedPay">已支付</span>
                                        <span v-if="item.PaymentType ==4&&!item.NeedPay">已退款</span>
                                        <span v-if="item.NeedPay" @click="routerBookComfirm(item)"><a class="" href="javascript:void(0)">去支付</a></span>
                                    </td>
                                    <td class="status">
                                        <span v-if="item.SettlementType == 1">单单清</span>
                                        <span v-if="item.SettlementType == 7">预付款支付</span>
                                        <span v-if="item.SettlementType != 1&&item.SettlementType != 7">信贷支付</span>
                                        <br>
                                        <span v-if="item.Status == 0">无效单</span>
                                        <span v-if="item.Status == 2">已锁定</span>
                                        <span v-if="item.Status == 8">取消单</span>
                                        <span v-if="item.Status == 9">新单</span>
                                        <span class="das" v-if="item.Status == 27" @mousemove="StatusIndex=index" @mouseout="StatusIndex=''">可入住</span>
                                        <span class="das" v-if="item.Status == 10 && item.SettlementType == 1 && item.NeedPay" @mousemove="StatusIndex=index" @mouseout="StatusIndex=''">以支付后订单状态为准</span>
                                        <span class="das" v-else-if="item.Status == 10" @mousemove="StatusIndex=index" @mouseout="StatusIndex=''">已确认</span>
                                        <br>
                                        <span v-if="item.CanCancel" @click="cancelOrder(item)"><a href="javascript:void(0)">去取消</a></span>
                                        <div v-if="item.Status>=10&&StatusIndex===index">
                                            <span v-for="i in item.ConfirmNOs">确认号:{{i}}<br></span>
                                            <span v-if="item.ConfirmNOs.length==0">确认号:暂无</span>
                                        </div>
                                    </td>
                                    <td class="oper">
                                        <span @mousemove="PhoneIndex=index" @mouseout="PhoneIndex=''">{{item.Oper}}</span>
                                        <div v-if="PhoneIndex === index">
                                            <div class="lab">电话:</div><div>{{item.Phone||'无'}}</div>
                                        </div>
                                    </td>
                                    <td>
                                        <a href="javascript:void(0)" @click="routerToDetails(item.OrderNO)">详情</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div class="table-loading" v-if="isLoading">
                                <Loading :isLoading="isLoading"></Loading>
                            </div>
                            <div class="table-no-more" style="width: 100%" v-if="!isLoading&&total ==0">
                                暂无数据...
                            </div>
                        </div>
                        <Paginate :pageIndex="Page" :pageTotal="Math.ceil(total/PageSize)" @select="pageSelect" v-if="total>10"></Paginate>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Modal from './../../common/cmpnt/Modal/modal'
    import Menu from './../../common/cmpnt/menu/Menu'
    import Paginate from './../../common/cmpnt/paginate/paginate.vue'//分页


    export default {
        name: "orderList",
        components: {
            DatePicker,
            Loading,
            Menu,
            Paginate,
            Modal
        },
        data: function () {
            return {
                PhoneIndex:'',
                StatusIndex:'',
                OrderList: [],
                OrderExcelList: [],
                CheckInNum: 0,
                UnpaidNum: 0,
                TimeType: 0,
                ThirdOrderNO: '',
                OrderNO: '',
                GustName: '',
                GustOrder:'',
                SearchType:'init',
                HotelName: '',
                isShow:true,
                Start: this.getDate(-5),
                End: this.getDate(2),
                Oper: '',
                total: 0,
                Source: "",
                Status: [],
                Statu:'',
                Payment:'',
                PaymentType: [],
                Page: 1,
                PageSize: 10,
                isLoading: false,
                isMore:false,
                FinalParams:{},
                ExcelTxt: '导出',
                DivDisable: false,
                calendar: {
                    show: false,
                    start: '',
                    begin: this.getDate(-5),
                    end: this.getDate(2),
                    select: (begin, end) => {
                        if (!begin) {
                            this.calendar.show = false;
                            this.calendar.begin = this.Start;
                            this.calendar.end = this.End;
                            return;
                        }

                        this.calendar.begin = begin;
                        this.calendar.end = end;
                        this.Start = begin;
                        this.End = end;
                        this.CheckInNumData();
                        // this.unpaidNumData();
                        this.$nextTick(function () {
                            this.calendar.show = false;
                            // this.changeFilter();
                        });
                    }
                },
                userInfo: this.dao.get('userInfo'),
                modal:{
                    show:false,
                    config:{}
                },
                cancelToken:'',
            }
        },
        watch:{
            Payment(key){
                if(key === ''){
                    this.PaymentType = [];
                }else if(key==='0'){
                    this.PaymentType = [0,1,2]
                }else if(key>2){
                    this.PaymentType = [key]
                }
            },
            Statu(key){
                if(key === ''){
                    this.Status = [];
                }else{
                    this.Status[0] = key
                }
            }

        },
        mounted() {
            this.initData();
            this.CheckInNumData();
            document.title='酒店订单---订房易';
        },
        methods: {
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;
                that.postRequest({
                    url: that.Api.cancelOrder,
                    params: that.cancelToken
                }).then(res => {
                    that.isLoading = false;
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                        
                    }
                });
            },
            // 选择页数
            pageSelect(val){
                this.total=0;
                this.OrderList=[];
                this.Page=val;
                this.FinalParams.Page = val;
                this.getOrderList();
            },
            routerToDetails(id){
                const {href} = this.$router.resolve({
                    name: 'OrderDetails',
                    params: { orderNO: id }
                })
                window.open(href, '_blank')
            },
            export2Excel() {
                var that = this;
                that.FinalParams.Page=1;
                that.FinalParams.PageSize = that.total;
                that.ExcelTxt = "正在导出...";
                that.DivDisable = true;
                that.postRequest({
                    url: (that.userInfo.Power&2) == 2 ? that.Api.getOrderList:that.Api.getMyOrderList,
                    params: that.FinalParams
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.OrderExcelList = res.Result;
                        require.ensure([], () => {
                            const { export_json_to_excel } = require('../../common/excel/Export2Excel'); //这里必须使用绝对路径
                            let tHeader = ['CN单号','客户订单号','入住日期', '离店日期','间夜数' ,'酒店','入住人','房型','间数','餐食金额','订单金额 ','币种','支付状态','订单状态','跟单人','预定日期','结算方式']; // 导出的表头名
                            const filterVal = ['OrderNO','ThirdOrderNO','CheckIn','CheckOut','NightCount','HotelName','Guest','RoomName','RoomCount','MealAmount','TotalAmount','Currency','PaymentType','Status','Oper','BookingOn','SettlementType']; // 导出的表头字段名
                            const list = that.tableExcelData(that.OrderExcelList);
                            const data = that.formatJson(filterVal, list);
                            export_json_to_excel(tHeader, data, '订单列表');// 导出的表格名称，根据需要自己命名
                            that.ExcelTxt = "导出";
                            that.DivDisable = false;
                        })
                    } else {
                        that.ExcelTxt = "导出";
                        that.DivDisable = false;
                        that.error({title: '提示', content: '订单导出失败！'});
                    }
                    that.FinalParams.PageSize = 10
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            tableExcelData(list){
                var l = [];
                for(let i=0; i<list.length; i++){
                    var lis = {
                        OrderNO:list[i].OrderNO,
                        ThirdOrderNO:list[i].ThirdOrderNO,
                        HotelName:list[i].HotelName,
                        RoomName:list[i].RoomName,
                        RoomCount:list[i].RoomCount,
                        NightCount:list[i].NightCount,
                        Oper:list[i].Oper,
                        MealAmount: list[i].Surcharge,
                        TotalAmount: list[i].TotalAmount,
                        Currency: list[i].Currency,
                        CheckIn: this.filterDateToYMDline(list[i].CheckIn),
                        CheckOut: this.filterDateToYMDline(list[i].CheckOut),
                        BookingOn: this.filterDateToYMDline(list[i].BookingOn),
                        PaymentType:list[i].PaymentType == 0 ? '未支付' : list[i].PaymentType == 1 ? '未支付' : list[i].PaymentType == 2 ? '未支付' : list[i].PaymentType == 3 ? '已支付' : list[i].PaymentType == 4 ? '已退款' : '',
                        Status:list[i].Status == 0 ? '无效单' : list[i].Status == 2 ? '已锁定' : list[i].Status == 8 ? '取消单' : list[i].Status == 9 ? '新单' : list[i].Status == 10 ? '已确认' : list[i].Status == 27 ? '可入住' : list[i].Status == 30 ? '罚金取消':'',
                        Guest:'',
                        SettlementType:list[i].SettlementType == 1 ? '单单清' : list[i].SettlementType == 7 ? '预付款支付' : '信贷支付',
                    };
                    var guest = '';
                    for(let j=0; j< list[i].Guest.length; j++){
                        guest = guest + list[i].Guest[j].FirstName + list[i].Guest[j].LastName + '、';
                    }
                    lis.Guest = guest;
                    l.push(lis)
                }
                return l
            },
            filterDateToYMDline(date) {
                if (!date) return '';
                var da = new Date(date);
                var year = da.getFullYear();
                var month = da.getMonth() + 1;
                var day = da.getDate();
                if (month < 10) {
                    month = '0' + month
                };
                if (day < 10) {
                    day = '0' + day
                };
                return year + '-' + month + '-' + day;
            },
            getUnpaid() {
                var that = this;
                that.Page = 1;
                var params = {
                    TimeType: that.TimeType,
                    OrderNO: that.OrderNO,
                    GustName: that.GustName,
                    HotelName: that.HotelName,
                    ThirdOrderNO: that.GustOrder,
                    Start: that.Start,
                    End: that.End,
                    Oper: that.Oper,
                    Source: that.Source,
                    Status: [9,10,27],
                    PaymentType: [0,1,2],
                    Page: that.Page,
                    PageSize: that.PageSize,
                }
                that.FinalParams = params;
                that.getOrderList()
                // this.unpaidNumData('check');
            },
            cancelOrder(item){
                if(!item.Token){
                    return
                }
                var that = this;
                var params = {
                    Token:item.Token
                }
                that.cancelToken = params
                that.modal={
                    show:true,
                    content:'确定要取消订单号:"' + item.OrderNO + '"的订单吗?',
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },

            routerBookComfirm(item){
                var that = this;
                var obj={
                    From:1,
                    HotelName:item.HotelName,
                    RoomName:item.RoomName,
                    RPName:'',
                    CheckIn:item.CheckIn,
                    CheckOut:item.CheckOut,
                    RoomCount:item.RoomCount,
                    AdultCount:'',
                    Star:'',
                    HotelAddress:'',
                    HotelPhone:'',
                    AdultPrice:item.TotalAmount,
                    days:item.NightCount,
                    Token:'',
                    CancelPolicy:'',
                    Breakfast:'',
                    Currency:'',
                    Tip:'',
                    Stock:'',
                    MaxPerson:'',
                    Breakfast:'',
                    DailyRates:'',
                    IsAskRoom:'',
                    details:'',
                    room:''
                }
                that.dao.set('bookInfo',obj);
                var time = Date.parse(new Date())
                that.$router.push('/bookComfirm?OrderNO='+item.OrderNO+'&time1='+time)
            },

            getCheckIn() {
                var that = this;
                that.Start = that.getDate(0);
                that.End = that.getDate(6);
                that.Payment = '';
                that.HotelName = '';
                that.Source = '';
                that.OrderNO = '';
                that.Oper = '';
                that.GustName = ''
                that.GustOrder = ''
                that.calendar.begin = that.getDate(0);
                that.calendar.end = that.getDate(6);
                that.TimeType = 1;
                that.Statu = 27;

                that.Page = 1;
                var params = {
                    TimeType: 1,
                    OrderNO: '',
                    GustName: '',
                    ThirdOrderNO:'',
                    HotelName: '',
                    Start: that.getDate(0),
                    End: that.getDate(6),
                    Oper: '',
                    Source: '',
                    Status: 27,
                    PaymentType: [],
                    Page: that.Page,
                    PageSize: 10,
                }
                that.FinalParams = params;
                that.getOrderList()
                // this.CheckInNumData('check')
            },
            // 数据查询
            getOrderList(){
                var that = this;
                that.isLoading = true;
                that.postRequest({
                    url: (that.userInfo.Power&2) == 2 ? that.Api.getOrderList:that.Api.getMyOrderList,
                    params: that.FinalParams
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.total = res.Total;
                        that.OrderList = res.Result;
                        that.OrderExcelList = that.OrderList;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    } else {
                        that.error({title: '提示', content: res.Msg || '数据搜索失败'});
                    }
                });
            },
            initData() {
                var that = this;
                that.Page = 1
                var params = {
                    TimeType: that.TimeType,
                    OrderNO: that.OrderNO,
                    Oper: that.Oper,
                    GustName: that.GustName,
                    ThirdOrderNO: that.GustOrder,
                    HotelName: that.HotelName,
                    Start: that.Start,
                    End: that.End,
                    Oper: that.Oper,
                    Source: that.Source,
                    Status: that.Status,
                    PaymentType: that.PaymentType,
                    Page: that.Page,
                    PageSize: that.PageSize,
                }
                that.FinalParams = params;
                that.getOrderList();
                // this.unpaidNumData();
            },
            CheckInNumData() {
                var that = this;
                var params = {
                    TimeType: 1,
                    OrderNO: '',
                    GustName: '',
                    HotelName: '',
                    ThirdOrderNO:'',
                    Start: that.getDate(0),
                    End: that.getDate(6),
                    Oper: '',
                    Source: '',
                    Status: 27,
                    PaymentType: [],
                    Page: 1,
                    PageSize: 0,
                }
                that.postRequest({
                    url: (that.userInfo.Power&2) == 2 ? that.Api.getOrderList:that.Api.getMyOrderList,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.CheckInNum = res.Total;
                    } else {
                        that.error({title: '提示', content: res.Msg || '数据搜索失败'});
                    }
                });
            },
            unpaidNumData() {
                var that = this;
                var params = {
                    TimeType: that.TimeType,
                    OrderNO: that.OrderNO,
                    GustName: that.GustName,
                    HotelName: that.HotelName,
                    ThirdOrderNO:that.GustOrder,
                    Start: that.Start,
                    End: that.End,
                    Oper: that.Oper,
                    Source: that.Source,
                    Status: [9,10,27],
                    PaymentType: [0,1,2],
                    Page: that.Page,
                    PageSize: that.PageSize,
                }
                that.postRequest({
                    url: (that.userInfo.Power&2) == 2 ? that.Api.getOrderList:that.Api.getMyOrderList,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.UnpaidNum = res.Total;
                    } else {
                        // $state.complete();
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/List.vue